import {Module} from "vuex";
import {RootState} from "@/store/index";

export interface HomeModuleState {
  menuActive: boolean;
}

const homeModuleData = (): HomeModuleState => {
  return {
    menuActive: false,
  };
};

export const HomeModule: Module<HomeModuleState, RootState> = {
  namespaced: true,
  state: homeModuleData(),
  mutations: {
    setMenuActive(state): void {
      state.menuActive = !state.menuActive;
    },
  },
  getters: {},
  actions: {},
};
